<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isRejectModalVisible">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body reject-reason-modal" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["RD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeRejectReason">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RR"]}} :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['PM']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['PM']['RR']" size="sm" v-model="obj_Reject.reason2" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationRejectReasonErrMsg() }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <Textarea vertical="" rows="7" class="form-control form-control-sm" :value="obj_Reject.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveRejectReason()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'GN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["AGI"]}}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MEM"]["U"]}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["RT"]}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TSID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                                <i @click="setSortTable('TSI')" :class="setSortLogo('TSI')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.add)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["OWN"]}}
                                            </template>
                                            <template v-else-if="header == 'S' && checkModuleAccess2(constAccessType.add)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["S"]}}
                                            </template>
                                            <template v-else-if="header == 'PM'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["PM"]}}
                                                <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["PA"]}}
                                                <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["BETRPT"]["DA"]}}
                                                <i @click="setSortTable('DA')" :class="setSortLogo('DA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'WTA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["PM"]["TO"]}} {{getLanguage["BETRPT"]["AMT"]}}
                                                <i @click="setSortTable('WTA')" :class="setSortLogo('WTA')" class="sortlogo"></i>
                                            </template>

                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['PM']['PPM']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs"
                                                  v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="dd_agentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGI']"
                                            openDirection="below" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :cacheOptions="false"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="arr_FV['U']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.CTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.CTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.CTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV.CTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV.CTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV.CTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['PM']['PM']}} :</span>
                                <CInput size="sm" :value="arr_FV['PC']" @change="v => arr_FV['PC'] = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["C"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('PM.C')"
                                            v-model="arr_FV['CI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['PM']['PPML']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["AGI"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                        <i @click="setSortTable('TSI')" :class="setSortLogo('TSI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["OWN"]}}
                                    </template>
                                    <template v-else-if="header == 'S' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["S"]}}
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["PM"]}}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["PA"]}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BETRPT"]["DA"]}}
                                        <i @click="setSortTable('DA')" :class="setSortLogo('DA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WTA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["TO"]}} {{getLanguage["BETRPT"]["AMT"]}}
                                        <i @click="setSortTable('WTA')" :class="setSortLogo('WTA')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' style="min-height: 150px;">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'GN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["AGI"]}}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["RT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color:#ff8c00;font-weight:700">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color:red;font-weight:900">{{getLanguage['MEM']['SU']}}</span>
                                        <i @click="setSortTable('TSI')" :class="setSortLogo('TSI')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["OWN"]}}
                                    </template>
                                    <template v-else-if="header == 'S' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["S"]}}
                                    </template>
                                    <template v-else-if="header == 'PM'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["PM"]}}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["PA"]}}
                                        <i @click="setSortTable('BA')" :class="setSortLogo('BA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["BETRPT"]["DA"]}}
                                        <i @click="setSortTable('DA')" :class="setSortLogo('DA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'WTA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["PM"]["TO"]}} {{getLanguage["BETRPT"]["AMT"]}}
                                        <i @click="setSortTable('WTA')" :class="setSortLogo('WTA')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_MemberPromotion.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberPromotion" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'GN'">
                                    <span class="grid-line">{{ data.GN }}</span>
                                    <span class="saggroupname">{{ data.SAGN }}</span>
                                    <span class="grid-line">({{ data.GPC }})</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <span class="grid-line kema-eft" v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="CheckingMember(data.AAGI,data.MI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                    <span class="grid-line kema-eft" v-else-if="(isSENS == 1 && data.AAGI != curAGI)">
                                        <div class="custom-tooltip">
                                            <span :style="getbgtooltip(data)">{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="custom-tooltiptext" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.TW == 0">
                                            <img src="../../../assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.HTWT">
                                            <img src="../../../assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom-tooltip" v-if="data.RP">
                                            <img src="../../../assets/icons/referral.svg" class="referral-icon" />
                                            <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line"><router-link :to="{ path:'/M/ML/SamePromotionIP', query:{ ip: data.AIP}}">{{ data.AIP }}</router-link></span>
                                </template>
                                <template v-else-if="header == 'TSID'">
                                    <span style="text-align:center;display:block">
                                        <span v-if="getUserInfo.AT!=4">
                                            <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                            </span>
                                            <span v-else-if="data.TSI > 0 && (isSENS == 1 && data.AAGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span v-else-if="getUserInfo.AT==4">
                                            <span v-if="data.SUBATSI > 0 && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span v-else-if="data.SUBATSI > 0 && (isSENS == 1 && data.AAGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                                <span style="color:darkorange">({{ data.SUBATSI }})</span> / <span style="color:red">({{ data.SUBATM }})</span>
                                            </span>
                                            <span class="grid-line" v-else>-</span>
                                        </span>
                                        <span class="grid-line" v-else>-</span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index1) in arry_systemId[data.I]">
                                                    <tr style="text-align: left;">
                                                        <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </span>
                                </template>
                                <template v-else-if="header == 'ACT' && checkModuleAccess2(constAccessType.add)">
                                    <span v-if="data.PG == 25 || data.PG == 26">-</span>
                                    <span v-else>
                                        <CDropdown :ref="'dd_assignto_' + index"
                                                   :toggler-text="renderAssignedTo(data.AT, data.ATPC)"
                                                   :color="renderAssignedToColor(data.AT)"
                                                   size="sm"
                                                   class="m-1 d-inline-block">
                                            <CDropdownItem v-if="data.canTakeover && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="assignPromotionRequest(true,data,index)">{{getLanguage['PM']['TAKE']}}</CDropdownItem>
                                            <CDropdownItem v-if="data.canHandover && ((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="assignPromotionRequest(false,data,index)">{{getLanguage['PM']['HAND']}}</CDropdownItem>
                                            <CDropdownItem v-if="data.canTakeover && (isSENS == 1 && data.AAGI != curAGI)">{{getLanguage['PM']['TAKE']}}</CDropdownItem>
                                            <CDropdownItem v-if="data.canHandover && (isSENS == 1 && data.AAGI != curAGI)">{{getLanguage['PM']['HAND']}}</CDropdownItem>
                                        </CDropdown>
                                    </span>
                                </template>
                                <template v-else-if="header == 'S' && checkModuleAccess2(constAccessType.add)">
                                    <CDropdown :ref="'dd_status_' + index"
                                               :toggler-text="renderStatus(data.Status)"
                                               :color="renderStatusColor(data.Status)"
                                               size="sm"
                                               class="m-1 d-inline-block"
                                               v-if="data.canUpdateStatus">
                                        <CDropdownItem v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="changeApproval(true,data,index)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="((isSENS == 1 && data.AAGI == curAGI) || isSENS == 0)" @click="changeApproval(false,data,index)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                        <CDropdownItem v-if="(isSENS == 1 && data.AAGI != curAGI)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="(isSENS == 1 && data.AAGI != curAGI)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                    </CDropdown>
                                    <div v-else>-</div>
                                </template>
                                <template v-else-if="header == 'PM'">
                                    <span class="grid-line">{{ renderPromotionCode(data.PC, data.PG) }}</span>
                                    <span class="grid-line">{{ renderPromotionGroup(data.PG, data.CDT, data.CDV) }}</span>
                                </template>
                                <template v-else-if="header == 'PA'">
                                    <div class="tableCtnRight" v-if="data.BA == 0">-</div>
                                    <div class="tableCtnRight" v-else>{{ renderBonusAmount(data.PG, data.BA, data.CS) }}</div>
                                </template>
                                <template v-else-if="header == 'CA'">
                                    {{ renderDepositAmount(data.PG, data.DA, data.CS) }}
                                </template>
                                <template v-else-if="header == 'WTA'">
                                    {{ renderTurnoverWinoverAmount(data.PG, data.WTA, data.CS) }}
                                </template>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constPromoGroup, constPromoGroupType, constRejectReasonP } from '@/modules/Constant.js'
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from "moment";
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker,
            draggable
        },
        data() {
            return {
                bool_fingerPrintLoading: [], // fingerprint/lastSystemID
                opened: [],
                arry_visitorMembers: [],
                arry_systemId: [],
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                arr_FV: {
                    "U": null,
                    "PC": "",
                    "CI": null,
                    "AGI": null,
                    "CTS": { startDate: "", endDate: "" }
                }, //Filter Value
                bool_isRejectModalVisible: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                arr_MemberPromotion: [],
                dd_agentgroup: [],
                dd_currency: [],
                dd_rejectreason: [],
                obj_Reject: {
                    "I": "",
                    "reason": null,
                    "reason2": "",
                    "R": ""
                },
                constAccessType: constAccessType,
                bool_rejectreasonErr: false,
                ddMemberList: [],
                AutoUpdateTO: null,
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                rtSubBrand: 0,
                defaultReportHeaders: ['NO', 'GN', 'U', 'CTS', 'TSID', 'ACT', 'S', 'PM', 'PA', 'CA', 'WTA'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
        },
        watch: {
            bool_isRejectModalVisible() {
                if (!this.bool_isRejectModalVisible && !this.bool_rejectreasonErr) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMemberPromotionList();
                this.getCurrencyList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/PendingPromtion`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                        if (!that.checkModuleAccess2(constAccessType.add)) {
                                            that.removeDefaultColumn('ACT')
                                            that.removeColumn('ACT')
                                        }

                                        if (!that.checkModuleAccess2(constAccessType.add)) {
                                            that.removeDefaultColumn('S')
                                            that.removeColumn('S')
                                        }

                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/PendingPromtion/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.CTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.CTS.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('PDU', 'P', type);
            },
            renderPromotionCode(promotionCode, commissionType) {
                if (commissionType == 25) {
                    return this.getLanguage["PM"]["TOCM"];
                }
                else if (commissionType == 26) {
                    return this.getLanguage["PM"]["WLCM"];
                }
                return promotionCode;
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor
                };
            },
            closeRejectReason() {
                this.bool_isRejectModalVisible = !this.bool_isRejectModalVisible;
                this.bool_rejectreasonErr = true;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getMemberPromotionList();
            },
            newSearch() {
                if (!this.bool_isRejectModalVisible) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getMemberPromotionList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getMemberPromotionList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.arr_FV["AGI"]) {
                        agi = this.arr_FV["AGI"].split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI"]) {
                    var agentList = this.arr_FV["AGI"].split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT == 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getDropdownList();
                    });
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_ad.R = event.target.value;
                }
            },
            getMemberPromotionList(isAutoUpdate = false) {
                this.bool_fullLoading = !isAutoUpdate;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.MI=" + (this.arr_FV["U"] == null ? "" : this.arr_FV["U"]) +
                        "&f.PC=" + (this.arr_FV["PC"] == null ? "" : this.arr_FV["PC"]) +
                        "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]) +
                        "&f.ATAGI=" + (this.arr_FV["SAGI"] == null ? (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]) : "4-" + this.arr_FV["SAGI"])
                    );

                    if (this.arr_FV.CTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.CTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                }

                this.getDataApi(`/api/mpromo/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_MemberPromotion = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            renderAssignedToColor(assignedTo) {
                return this.$parent.checkpendingColor(assignedTo);
            },
            renderAssignedTo(assignedTo, assignedToPrefixCode) {
                if (assignedTo == "") {
                    return this.getLanguage["GL"]["PEND"];
                } else {
                    return assignedTo + " (" + assignedToPrefixCode + ")";
                }
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            renderStatusColor(int_status) {
                switch (int_status) {
                    case 2:
                        return "success";
                        break;
                    case 3:
                        return "danger";
                        break;
                    default:
                        return "dark";
                        break;
                }
            },
            assignPromotionRequest(bool_isTakeover, d, index) {
                this.bool_fullLoading = true;
                var that = this;

                var dt = {
                    I: d.I,
                    UTS: d.UTS,
                    AC: bool_isTakeover ? 11 : 12
                };

                this.postDataApi(`/api/mpromo/ao`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.$refs["dd_assignto_" + index][0].visible = false;
                            that.getMemberPromotionList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            changeApproval(bool_isApproved, d, index) {
                if (bool_isApproved) {

                    this.$fire({
                        title: this.getLanguage["PM"]["CAE"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            var that = this;

                            if (d.PG == 25 || d.PG == 26) {
                                var obj_Comm = {
                                    "AC": 1,
                                    "CNT": "",
                                    "CNM": "",
                                    "R": [],
                                };
                                obj_Comm["AC"] = 2;
                                obj_Comm["R"] = [];
                                obj_Comm["CNT"] = d.PG == 25 ? this.getLanguage["PM"]["CNT1"] : this.getLanguage["PM"]["CNT2"];
                                obj_Comm["CNM"] = d.PG == 25 ? this.getLanguage["PM"]["CNM1"] : this.getLanguage["PM"]["CNM2"];

                                obj_Comm.R.push({
                                    "I": d.I,
                                    UTS: d.UTS,
                                });

                                this.postDataApi(`/api/mpromo/sc`, obj_Comm,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        if (s) {
                                            that.getMemberPromotionList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                            else {
                                var dt = {
                                    I: d.I,
                                    UTS: d.UTS,
                                    AC: 2,
                                    PSRT: "::[PM][PST]::",
                                    PSRM: "::[PM][PST]::",
                                };

                                this.postDataApi(`/api/mpromo/ap`, dt,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.$refs["dd_status_" + index][0].visible = false;
                                            that.getMemberPromotionList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    });
                            }
                        }
                    });
                }
                else if (d.PG == 25 || d.PG == 26) {
                    this.$fire({
                        title: this.getLanguage["PM"]["CRE"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;

                            var obj_Comm = {
                                "AC": 1,
                                "CNT": "",
                                "CNM": "",
                                "R": [],
                            };
                            obj_Comm["AC"] = 3;
                            obj_Comm["R"] = [];

                            obj_Comm.R.push({
                                "I": d.I,
                                UTS: d.UTS,
                            });

                            this.postDataApi(`/api/mpromo/sc`, obj_Comm,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.getMemberPromotionList();
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                });
                        }
                    });
                }
                else {
                    this.dd_rejectreason = [{
                        id: "1",
                        label: this.getLanguage['PM']['UPP']
                    },
                    {
                        id: "2",
                        label: this.getLanguage['PM']['CNM']
                    },
                    {
                        id: "3",
                        label: this.getLanguage['PM']['SI']
                    },
                    {
                        id: "4",
                        label: this.getLanguage['PM']['ND']
                    },
                    {
                        id: "5",
                        label: this.getLanguage['PM']['MD']
                    },
                    {
                        id: "999",
                        label: this.getLanguage['PM']['O']
                    }
                    ];
                    this.obj_Reject = {
                        I: d.I,
                        UTS: d.UTS,
                        AC: 3,
                        reason: null,
                        reason2: "",
                        R: ""
                    };

                    this.bool_isRejectModalVisible = true;
                    this.bool_rejectreasonErr = false;
                }
            },
            saveRejectReason() {
                this.bool_rejectreasonErr = false;
                var that = this;
                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;
                if (rejectreason != "" && rejectreason != null) {

                    this.$fire({
                        title: this.getLanguage["PM"]["CRE"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;

                            var dt = {
                                I: this.obj_Reject.I,
                                UTS: this.obj_Reject.UTS,
                                AC: 3,
                                RR: rejectreason,
                                R: this.obj_Reject.R,
                                PSRT: "::[PM][PRT]::",
                                PSRM: "::[PM][PRM]::",
                            };

                            this.postDataApi(`/api/mpromo/ap`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.bool_isRejectModalVisible = false;
                                        that.getMemberPromotionList();
                                    }
                                });
                        }
                    });
                }
                else {
                    this.bool_rejectreasonErr = true;
                }
            },
            ValidationRejectReasonErrMsg() {
                if (this.bool_rejectreasonErr) {
                    return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage["PM"]["RR"]);
                }
            },
            renderPromotionGroup(int_promoGroup, int_conditionDurationType, int_conditionDurationValue) {
                var promoGroup = "";
                for (var i = 0; i < constPromoGroup.length; i++) {
                    for (var j = 0; j < constPromoGroup[i].children.length; j++) {
                        if (constPromoGroup[i].children[j].id == int_promoGroup) {
                            promoGroup = constPromoGroup[i].children[j].label;
                            break;
                        }
                    }
                }

                if (int_promoGroup == 3 || int_promoGroup == 5) {
                    var durationType = "";
                    for (var i = 0; i < constPromoGroupType.length; i++) {
                        if (constPromoGroupType[i].id == int_conditionDurationType) {
                            durationType = constPromoGroupType[i].label;
                            break;
                        }
                    }

                    promoGroup += " [" + int_conditionDurationValue + " " + durationType + "]";
                }

                return promoGroup;
            },
            renderPromotionTurnover(int_turnoverType, dec_turnoverValue, str_currencySymbol, dec_promoMaxAmount, dec_promoBonusRatio) {
                if (int_turnoverType == 1 || int_turnoverType == 4) {
                    return dec_turnoverValue.toFixed(0) + " * N";
                }
                else if (int_turnoverType == 3) {
                    if (dec_promoMaxAmount > 0) {
                        let maximumWithdrawTurnover = ((dec_promoMaxAmount * 100 / dec_promoBonusRatio) + dec_promoMaxAmount) * dec_turnoverValue;
                        return dec_turnoverValue.toFixed(0) + " * N (" +
                            this.getLanguage["PM"]["MAX"] + ": " + this.formatNumber(maximumWithdrawTurnover, 2, str_currencySymbol) + ")";
                    }
                    else {
                        return dec_turnoverValue.toFixed(0) + " * N";
                    }
                }
                else {
                    return this.formatNumber(dec_turnoverValue, 2, str_currencySymbol);
                }
            },
            renderBonusAmount(int_promogroup, dec_bonusAmount, str_currencySymbol) {
                if (int_promogroup == 5 || int_promogroup == 6 || int_promogroup == 15 || int_promogroup == 16) {
                    if (dec_bonusAmount > 0) {
                        return this.formatNumber(dec_bonusAmount, 2, str_currencySymbol);
                    }
                    else {
                        return "-";
                    }
                }
                else {
                    return this.formatNumber(dec_bonusAmount, 2, str_currencySymbol);
                }
            },
            renderDepositAmount(int_promogroup, dec_depositAmount, str_currencySymbol) {
                if (dec_depositAmount > 0) {
                    return this.formatNumber(dec_depositAmount, 2, str_currencySymbol);
                }
                else {
                    return "-";
                }
            
            },
            renderTurnoverWinoverAmount(int_promogroup, dec_turnoveWinoverAmount, str_currencySymbol) {
                if (dec_turnoveWinoverAmount > 0) {
                    return this.formatNumber(dec_turnoveWinoverAmount, 2, str_currencySymbol);
                }
                else {
                    return "-";
                }

            },
            renderParticipateAmount(int_promoGroup, dec_depositAmount, dec_turnoverAmout, dec_lossAmount, str_currencySymbol) {
                switch (int_promoGroup) {
                    case 1:
                        return "-";
                        break;
                    case 2:
                    case 3:
                    case 4:
                        return this.getLanguage["PM"]["CDA"] + " : " + this.formatNumber(dec_depositAmount, 2, str_currencySymbol);
                        break;
                    case 5:
                        if (dec_turnoverAmout > 0)
                            return this.getLanguage["PM"]["TO"] + " : " + this.formatNumber(dec_turnoverAmout, 2, str_currencySymbol);
                        else return "-";
                        break;
                    case 6:
                        if (dec_lossAmount > 0)
                            return this.getLanguage["PM"]["CLA"] + " : " + this.formatNumber(dec_lossAmount, 2, str_currencySymbol);
                        else return "-";
                        break;
                    case 7:
                        return "-";
                        break;
                    default:
                        return "-";
                }
            },
            clearDateRangeFilter() {
                this.arr_FV.CTS = {
                    startDate: "",
                    endDate: ""
                };
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getMemberPromotionList(true);
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                if (!that.checkModuleAccess2(constAccessType.add)) {
                    that.removeDefaultColumn('ACT')
                }
                if (!that.checkModuleAccess2(constAccessType.add)) {
                    that.removeDefaultColumn('S')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.PDU';
            this.arr_FV['AGI'] = this.$route.query.agi;
            if (this.$route.query.ci) {
                //this.str_FV[6].FV = [];
                this.arr_FV['CI'] = this.$route.query.ci;
            }

            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0);
            }
            else {
                this.getDropdownList();
                this.getCurrencyList();
            }
            this.getMemberPromotionList();
            this.AutoUpdate();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        }
    }

</script>




// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/Promotion.vue